/**
 * TEMA CLARO — "papel", com ilhas de tela.
 *
 * Os papéis (não os pigmentos) vêm de `styles/global/tokens.ts`, que por sua vez
 * sai de `alfredo-site/docs/sistema-de-design.md`. Ver o cabeçalho do tokens.ts
 * para a ideia inteira; aqui fica só o que MUDOU e por quê.
 *
 *  · `text` era `#596267ff` (um cinza-azulado) e passou a ser `--carvao`. O
 *    valor antigo tinha oito dígitos — o `ff` no fim é alpha, e várias telas
 *    concatenam sufixo de opacidade (`colors.text + "90"`), o que produzia
 *    `#596267ff90`: cor inválida, que o navegador descarta em silêncio.
 *  · `selection` era `#88DBFE`. Esse azul é o BRILHO do rosto do ícone, não a
 *    tinta: em papel ele não sustenta texto. Quem faz ação e link é `--tinta`.
 *  · `border`, `borderColor`, `selectionDark`, `label` e `danger` são usados em
 *    ~200 lugares da árvore e NÃO EXISTIAM neste objeto. Resolviam para
 *    `undefined`, e toda regra que dependia deles era descartada — é por isso
 *    que havia borda que não aparecia. Agora existem.
 *
 * O AMARELO CONTINUA SENDO A CARA DA CASA. Ele fica em `modalColor` (cabeçalho
 * de tabela, painel, barra superior), que é uso de MOLDURA — e o texto por cima
 * dele é `--carvao`, a única tinta que o ladrilho cheio aguenta.
 */
import { CENTRAL, ESTRUTURA, SEMANTICAS } from "../global/tokens";

export const lightTheme = {
  title: "light",
  colors: {
    /** Superfície de trabalho: tabela, formulário, texto corrido. */
    primary: CENTRAL.papel,
    /** Fundo de página e de cartão. */
    background: CENTRAL.papel2,
    text: ESTRUTURA.carvao,
    /** Ação e link. 4,5:1 contra o lavado. */
    selection: CENTRAL.tinta,
    /**
     * Mais ênfase contra o fundo ATUAL — no papel, mais escuro.
     * O par desta linha vive em `dark.ts`, onde a mesma ideia vira mais CLARO.
     * O nome herdou o "Dark" de quando havia um tema só.
     */
    selectionDark: "#065C99",
    /** A moldura amarela — cabeçalho e painel. Só carvão por cima. */
    modalColor: CENTRAL.ladrilho,
    /**
     * O texto que vai SOBRE `selection` — botão primário, chip aceso, aba ativa.
     *
     * Ele existe porque `selection` NÃO é a mesma cor nos dois temas: aqui é a
     * tinta azul, e no escuro é o ladrilho amarelo. Os 17 botões primários da
     * árvore tinham `color: white` fixo — que funciona sobre o azul (4,9:1) e
     * MORRE sobre o amarelo (1,22:1, medido no navegador). Com o token, cada
     * tema diz quem aguenta ficar por cima da sua própria cor de ação.
     */
    textOnPrimary: "#FFFFFF",
    /** Contorno de controle. Precisa passar em 1.4.11, então é o forte. */
    border: ESTRUTURA.linhaForte,
    borderColor: ESTRUTURA.linhaForte,
    /** Rótulo miúdo e texto de apoio. */
    label: ESTRUTURA.carvao2,
    danger: SEMANTICAS.claro.erro,
    bom: SEMANTICAS.claro.bom,
    aviso: SEMANTICAS.claro.aviso,
    /** Fundo de destaque — é o da linha selecionada da tabela. */
    lavado: CENTRAL.lavado,
    /** O amarelo que sobrevive ao papel, para borda e ícone sobre claro. */
    ladrilhoBorda: CENTRAL.ladrilhoBorda,
  },
};
